'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var InternalCheckbox_web = require('../../internal/InternalCheckbox/InternalCheckbox.web.cjs');
var Checkbox_web_styles = require('./Checkbox.web.styles.cjs');

/**
 * An input control that allows a user to select one or more options from a number of choices
 *
 * {@link https://aviary.fullscript.io/latest/components/checkbox/web-emr0d1qA | Documentation}
 *
 * {@link https://git.fullscript.io/developers/aviary/-/blob/development/packages/aviary-web/src/components/atoms/Checkbox/Checkbox.web.tsx | View in GitLab}
 *
 * @scope Core
 */ const Checkbox = ({ children, alignment = "center", customCss, ...rest })=>{
    const labelStyles = alignment === "top" && Checkbox_web_styles.topAlignment;
    return /*#__PURE__*/ jsxRuntime.jsx(InternalCheckbox_web.InternalCheckbox, {
        "data-testid": "aviary-checkbox",
        css: customCss,
        labelStyle: labelStyles,
        ...rest,
        children: children
    });
};

exports.Checkbox = Checkbox;
//# sourceMappingURL=Checkbox.web.cjs.map
